import React, { createContext, useEffect, useState } from 'react';
import { cn } from '../cn';

export type AccordionStateContextValue = {
  currentActiveId: string | null,
  setCurrentActiveId: (id: string | null) => void,
  showOne: boolean,
};
export const AccordionStateContext = createContext<AccordionStateContextValue>({
  currentActiveId: null,
  setCurrentActiveId: (id: string | null): void => undefined,
  showOne: false,
});

export type AccordionProps = React.PropsWithChildren<{
  className?: string,
  showOne?: boolean,
  defaultActiveId?: string,
  activeId?: string,
  onActiveChange?: (id: string | null) => void,
  id?: string,
}>;

export const Accordion = (props: AccordionProps): JSX.Element => {
  const [currentActiveId, innerSetCurrentActiveId] = useState<string | null>(props.activeId || null);
  const setCurrentActiveId = (id: string | null) => {
    let newId = id;
    if(props.showOne) {
      newId = currentActiveId === id ? null : id;
    }
    innerSetCurrentActiveId(newId);
    props.onActiveChange && props.onActiveChange(newId);
  }
  useEffect(() => {
    innerSetCurrentActiveId(props.activeId || null);
  }, [props.activeId]);

  return (
    <div id={props.id} className={cn(
      'flex flex-col gap-8',
      props.className
    )}>
      <AccordionStateContext.Provider value = {{ currentActiveId, setCurrentActiveId, showOne: props.showOne === true }}>
        {props.children}
      </AccordionStateContext.Provider>
    </div>
  );
};
